var exports = {
  "uW": "xa15a2ab7--86a320--section",
  "AS": "xa15a2ab7--86a320--item",
  "xl": "xa15a2ab7--86a320--with-borders",
  "vW": "xa15a2ab7--86a320--inner",
  "Yg": "xa15a2ab7--86a320--with-border",
  "kp": "xa15a2ab7--86a320--with-bottom-border",
  "DD": "xa15a2ab7--86a320--title",
  "R_": "xa15a2ab7--86a320--heading",
  "VA": "xa15a2ab7--86a320--subtitle",
  "_F": "xa15a2ab7--86a320--overflow-hidden",
  "ZO": "xa15a2ab7--86a320--hide-for-print",
};

module.exports = exports;
